import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ImportFileCsvStatus } from 'src/app/interfaces/importFileCsvStatus';
import { ImportFileXlsxStatus } from 'src/app/interfaces/importFileXlsxStatus';
import { URL } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class ImportFileService {
  private readonly http = inject(HttpClient);

  /******************************************************************************************
   * The function that upload the file and get the status                                   *
   *                                                                                        *
   * @param functionId - The ID of the importFile function that will be used for the upload *
   * @param file - The file which will be treated                                           *
   *                                                                                        *
   * @returns {Observable<ImportFileCsvStatus>}                                             *
   *****************************************************************************************/
  upload(functionId: number, file: File): Observable<ImportFileCsvStatus> {
    const formData: FormData = new FormData();
    formData.append('file', file);
    return this.http.post<ImportFileCsvStatus>(`${URL.url}${URL.upload}` + functionId, formData, {});
  }

  /********************************************************************
   * The function download the file based on the ID of the file       *
   *                                                                  *
   * @param fileId - The ID of the file that we download              *
   * @returns {Observable<any>}                                       *
   ********************************************************************/
  downloadFile(fileId: number): Observable<any> {
    return this.http.get(`${URL.url}downloadFile/${fileId}`, { responseType: 'blob', observe: 'response' });
  }

  downloadAudtiFile(fileId: number): Observable<any> {
    return this.http.get(`${URL.url}downloadFileAudits/${fileId}`, { responseType: 'blob', observe: 'response' });
  }

  getStatusesByImportFileId(id: number): Observable<ImportFileCsvStatus[]> {
    return this.http.get<ImportFileCsvStatus[]>(`${URL.url}${URL.importFile}/` + id);
  }

  /*******************************************************************************************
   * Get the status of the xlsx Function based on the importFile ID                          *
   *                                                                                         *
   * @param id - The ID of the ImportFile                                                    *
   * @returns {Observable<ImportFileXlsxStatus[]>}                                           *
   *******************************************************************************************/
  getXlsxStatusesByImportFileId(id: number): Observable<ImportFileXlsxStatus[]> {
    return this.http.get<ImportFileXlsxStatus[]>(`${URL.url}${URL.importFileXlsxStatus}${id}`);
  }

  /*******************************************************
   * Get the status of the importFileCsv function        *
   *                                                     *
   * @param id - The ID of the importFileCsv             *
   * @returns {Observable<ImportFileCsvStatus>}          *
   *******************************************************/
  getStatus(id: number): Observable<ImportFileCsvStatus> {
    return this.http.get<ImportFileCsvStatus>(`${URL.url}importFileCsvStatus/${id}`);
  }
}
